// src/i18n/en/views/iframes.js
export const iframes = {
  pricing: {
    title: "Pricing calculator",
    description:
      "Configure base prices and per-unit add-ons per plan; invoices show tax as a separate line.",
    src: "https://player.vimeo.com/video/00000001",
    ariaLabel: "Video: Pricing calculator (EN)",
  },
  connectBooking: {
    title: "Connect Booking.com",
    description:
      "Step-by-step guide to link your property to Booking.com through the Channel Manager.",
    src: "https://player.vimeo.com/video/00000002",
    ariaLabel: "Video: Connect Booking.com (EN)",
  },
  connectAirbnb: {
    title: "Connect Airbnb (via Channex)",
    description:
      "Enable the Airbnb connection from your PMS using Channex and sync availability and rates.",
    src: "https://player.vimeo.com/video/00000003",
    ariaLabel: "Video: Connect Airbnb (EN)",
  },
  channexCertification: {
    title: "Channex Certification · PMS",
    description:
      "Requirements and tests to complete PMS certification with Channex (full sync, prices, restrictions).",
    src: "https://player.vimeo.com/video/00000004",
    ariaLabel: "Video: Channex certification (EN)",
  },
  hotelCalendar: {
    title: "Hotel calendar (multi-room)",
    description:
      "Manage bookings by room type and instance; avoid overbookings with a structured view.",
    src: "https://player.vimeo.com/video/00000005",
    ariaLabel: "Video: Hotel calendar (EN)",
  },
  apartmentCalendar: {
    title: "Apartments calendar",
    description:
      "Blocks, day prices and stays in a per-property calendar.",
    src: "https://player.vimeo.com/video/00000006",
    ariaLabel: "Video: Apartments calendar (EN)",
  },
  guestCheckin: {
    title: "WhatsApp check-in",
    description:
      "Guests scan their ID, pass identity verification and sign digitally from their phone.",
    src: "https://player.vimeo.com/video/00000007",
    ariaLabel: "Video: WhatsApp check-in (EN)",
  },
  identityVerification: {
    title: "Identity verification & e-signature",
    description:
      "Selfie check, MRZ/PDF417 reading and secure e-signature for compliance.",
    src: "https://player.vimeo.com/video/00000008",
    ariaLabel: "Video: Identity verification (EN)",
  },
  smartLocks: {
    title: "Smart locks",
    description:
      "Send automatic access codes—no keys or waiting. Supports dynamic codes.",
    src: "https://player.vimeo.com/video/00000009",
    ariaLabel: "Video: Smart locks (EN)",
  },
  reviewsAutomation: {
    title: "Reviews automation",
    description:
      "Schedule review reminders and grow your property’s reputation.",
    src: "https://player.vimeo.com/video/00000010",
    ariaLabel: "Video: Reviews automation (EN)",
  },
};
